module.exports = __webpack_public_path__ + "static/media/hero-student-bg.8cf74c27.svg";